module.exports = __webpack_public_path__ + "66fbca723bbad1b64c9eaffc9769a73e.svg";